const adjustPrice = (initialAmount, remainingAmount) => {
  if (remainingAmount < 0) {
    return [initialAmount + remainingAmount, 0]
  }
  return [initialAmount, remainingAmount]
}

export { adjustPrice }
